import { Typography } from '@mui/material'
import { ReactNode } from 'react'

import { HelperWrapper } from 'src/components/helper-wrapper'

import { useStyles } from '../styles'

interface IProps {
  children: ReactNode
}

export const MapWrapper = ({ children }: IProps) => {
  const classes = useStyles()

  return (
    <div className={classes.radioButtons}>
      <Typography style={{ marginBottom: 10 }} className={classes.radioLabel}>
        <HelperWrapper t="scan-form-map-label" />
      </Typography>
      {children}
    </div>
  )
}
